import { forwardRef } from "react";
import Turnstile from "../turnstile/Turnstile";

// Formularfeld mit Label oben, Unterlinie und Fehlertext (react-hook-form register-kompatibel).
export const FormField = forwardRef(function FormField(
    { label, error, as = "input", className = "", children, ...props },
    ref,
) {
    const Tag = as;
    const errorId = error ? `${props.name}-fehler` : undefined;
    return (
        <label className={`field ${className}`}>
            {label}
            <Tag
                ref={ref}
                className="field-input"
                aria-invalid={error ? "true" : undefined}
                aria-describedby={errorId}
                {...props}
            >
                {children}
            </Tag>
            {error && (
                <span id={errorId} className="field-error">
                    {error}
                </span>
            )}
        </label>
    );
});

// Honeypot + Zeitstempel + Turnstile wie bisher in den öffentlichen Formularen.
export const SpamProtection = ({ register, setValue, turnstileRef, error }) => (
    <>
        <input
            type="text"
            tabIndex={-1}
            autoComplete="off"
            {...register("website")}
            className="hidden"
            aria-hidden="true"
        />
        <input type="hidden" {...register("formStartedAt", { valueAsNumber: true })} />
        <div className="col-span-full">
            <Turnstile
                ref={turnstileRef}
                onVerify={(token) => setValue("turnstileToken", token, { shouldValidate: true })}
                onExpire={() => setValue("turnstileToken", "", { shouldValidate: false })}
            />
            {error && <p className="field-error mt-2">{error}</p>}
        </div>
    </>
);

export const turnstileRequired = (value) => !process.env.REACT_APP_TURNSTILE_SITE_KEY || Boolean(value);

export const SentMessage = ({ title, text }) => (
    <div role="status" className="col-span-full py-6 font-caslon text-[26px] leading-[1.3]">
        {title}
        {text && <div className="mt-2.5 font-figtree text-[15px] text-forest/70">{text}</div>}
    </div>
);

export const FormError = ({ children }) =>
    children ? (
        <div role="alert" className="col-span-full text-sm text-fehler">
            {children}
        </div>
    ) : null;
